<div class="flex justify-between mb-2">
    <div class="flex items-center">
        <div class="w-[8px] h-[20px] bg-[#0F917A] mr-[6px]"></div>
        <div class="font-bold text-[16px]">{{ tableTitle | translate }}</div>
    </div>
    <div class="primary-small-btn !h-[30px] !text-[14px] mr-1" *ngIf="showDownload" (click)="onDownload()" [class.disabled]="downloading">
        <svg-icon [iconName]="'new/download_ce.svg'" class="mr6" [size]="16"></svg-icon>{{ "DOWNLOAD" | translate }}
  </div>
  </div>
  <div class="mb-2 rebate-table">
    <nz-table
    [nzFrontPagination]="false"
    [nzData]="data"
    [nzTotal]="total"
    [nzPageIndex]="pageIndex"
    [nzPageSize]="pageSize"
    [nzShowPagination]="pagination"
    (nzPageIndexChange)="onPageChange($event, pageSize)"
    (nzPageSizeChange)="onPageChange(pageIndex, $event)"
    [nzScroll]="{ x: scrollWidth ? scrollWidth : 'max-content' }"
  >
    <thead>
      <tr>
        <th *ngFor="let col of columns" [nzWidth]="col.width || null" [nzLeft]="col.fixed === 'left'"
        [nzRight]="col.fixed === 'right'" [ngClass]="{ '!text-center': col.align === 'center' }">{{ col.title | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of data">
        <td *ngFor="let col of columns" [nzLeft]="col.fixed === 'left'" [nzRight]="col.fixed === 'right'" [ngClass]="{ '!text-center': col.align === 'center' }">
          <ng-container *ngIf="col.template; else defaultCell">
            <ng-container *ngTemplateOutlet="col.template; context: { $implicit: row[col.key], row: row }"></ng-container>
          </ng-container>
  
          <ng-template #defaultCell>
          <ng-container *ngIf="col.key === 'targetRebateAmount'; else normalCell">
            {{ calcTargetRebateAmount(row.purchaseTarget, row.rewardRatio) }}
          </ng-container>
          <ng-template #normalCell>
            {{ row[col.key] }}
          </ng-template>
        </ng-template>
        </td>
      </tr>
    </tbody>
  </nz-table>
  </div>
  

  